
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const MilkCartonIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M30.5 11.5C30.5 9.567 32.067 8 34 8H62C63.933 8 65.5 9.567 65.5 11.5V14.2251L75.18 25.7488C75.7096 26.3794 76 27.1765 76 28V84.5C76 86.433 74.433 88 72.5 88H23.5C21.567 88 20 86.433 20 84.5V28C20 27.1765 20.2904 26.3794 20.82 25.7488L30.5 14.2251V11.5ZM35.631 19L31.011 24.5H49.869L54.489 19H35.631ZM62 20.9416L55 29.2749V81H69V29.2749L62 20.9416ZM48 81V31.5H27V81H48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 28L34 15.5V11.5H62V15.5L72.5 28V84.5H51.5H23.5V28Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M30.5 11.5C30.5 9.567 32.067 8 34 8H62C63.933 8 65.5 9.567 65.5 11.5V14.2251L75.18 25.7488C75.7096 26.3794 76 27.1765 76 28V84.5C76 86.433 74.433 88 72.5 88H23.5C21.567 88 20 86.433 20 84.5V28C20 27.1765 20.2904 26.3794 20.82 25.7488L30.5 14.2251V11.5ZM35.631 19L31.011 24.5H49.869L54.489 19H35.631ZM62 20.9416L55 29.2749V81H69V29.2749L62 20.9416ZM48 81V31.5H27V81H48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 28L34 15.5V11.5H62V15.5L72.5 28V84.5H51.5H23.5V28Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
